export const PIN_STATE_LABELS: Record<string, string> = {
  waiting: 'در انتظار اجرا',
  inprogress: 'در حال اجرا',
  done: 'پایان یافته',
  refund: 'بازپس گرفته شده'
};

export const PIN_AVAILABILITY_LABELS: Record<string, string> = {
  free: '',
  reserve: 'رزرو شده',
  purchased: 'به فروش رفته'
};

export const PIN_ROUTES = {
  list: '/services/promotion-center/pin-list',
  details: '/services/promotion-center/pin-details/:pinId',
  buyPackage: '/services/promotion-center/pin-buy-package',
  basket: '/services/promotion-center/pin-basket',
  paymentSuccess: '/services/promotion-center/pin-payment-success'
} as const;
